/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CML } from '@coursera-web/cml';

import { Grid, Typography2 } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

import type { GraphQLCML } from 'bundles/collections-tool/types/collectionTypesSU';
import { getCMLShape } from 'bundles/enterprise-legacy-learner-home/utils/xdpUtils';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

const styles = {
  title: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  list: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
  listItem: css`
    margin-bottom: 0;
  `,
  itemContent: css`
    display: flex;
    align-items: flex-start;
    gap: var(--cds-spacing-100);
  `,
  icon: css`
    flex-shrink: 0;
    margin-top: var(--cds-spacing-50);
  `,
};

type Props = {
  titleTag?: React.ElementType;
  cmlLearningObjectives: Array<GraphQLCML>;
  oneColumnPerRow?: boolean;
};

export default function CmlLearningObjectives({ oneColumnPerRow, titleTag = 'h2', cmlLearningObjectives = [] }: Props) {
  if (cmlLearningObjectives.length === 0) return null;

  return (
    <div data-testid="cml-learning-objectives">
      <Typography2 component={titleTag} variant="bodySecondary" css={styles.title}>
        {_t('What you will learn')}
      </Typography2>
      <Grid container component="ul" css={styles.list} spacing={16}>
        {cmlLearningObjectives.map(({ cml }) => (
          <Grid item component="li" xs={12} md={oneColumnPerRow ? 12 : 6} key={cml.value} css={styles.listItem}>
            <div css={styles.itemContent}>
              <CheckIcon size="large" color="success" css={styles.icon} />
              <Typography2 variant="bodyPrimary" component="div">
                {cml && (
                  <CML
                    cml={getCMLShape(cml)}
                    shouldRenderMath={false}
                    shouldRenderCode={false}
                    shouldRenderAssets={false}
                    isCdsEnabled
                  />
                )}
              </Typography2>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
